import { endpoints } from "src/utils";
import { createListHook } from "src/actions/utils/create-action";


/**
 * Hook to fetch current user's roles
 * @param {Object} args - Fetch arguments (params, config, etc.)
 * @returns {Object} { data, loading, error, validating, empty, refresh }
 */
export const useGetMyRoles = createListHook(endpoints.me.roles);
